import React, { useState, useContext } from "react";
import { Modal, Input, message } from "antd";
import Template from "../assests/ViewBirthday.png";
import TestImage from "../assests/TestImage.jpg";
import axios from "axios";
import { AuthContext } from "../context/AuthContext"
import UserAvatar from "../assests/user_avatar.png"


const { TextArea } = Input;

export default function ViewBirthDay({ employee }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [wishText, setWishText] = useState("");

    const { backUrl, authData } = useContext(AuthContext)

    const employeeName =
        employee?.id !== 34 ? employee?.full_name : employee?.user?.last_name;
    const organizationName = employee?.organisation_name;
    const departmentName = employee?.department_name;
    const designation = employee?.designation_name;

    console.log("Employee Photo : ", employee)

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);

    const handleSendWish = async () => {
        if (!wishText.trim()) {
            message.warning("Please enter your wish before sending 🎂");
            return;
        }

        try {
            await axios.post(
                `${backUrl}/api/probation/celebrations/send/`,
                {
                    receiver_id: employee?.id,
                    occasion: "BIRTHDAY",
                    message: wishText,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            console.log(`Wish sent to ${employeeName}: ${wishText}`);
            alert("🎉 Your wish has been sent successfully!");
            setWishText("");
            setIsModalVisible(false);
        } catch (error) {
            console.error("Error sending wish:", error);
            message.error("Failed to send your wish. Please try again.");
        }
    };

    return (
        <>
            <style>{`
                .birthday-card-container {
                    position: relative;
                    width: 430px;
                    height: 230px;
                    overflow: hidden;
                    margin: 0 auto;
                    border-radius: 12px;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.3);
                    font-family: 'Dancing Script', cursive;
                }

                .birthday-card-bg {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0.8;
                }

                .birthday-card-photo {
                    position: absolute;
                    top: 50px;
                    left: 50px;
                    width: 117px;
                    height: 122px;
                    object-fit: cover;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.4);
                }

                .birthday-card-details {
                    position: absolute;
                    top: 70px;
                    left: 220px;
                    color: #3b2b2b;
                    text-align: left;
                    line-height: 1.3;
                }

                .birthday-card-name {
                    margin: 0 0 10px 0;
                    font-size: 12px;
                    color: #9b4d4d;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
                }

                .birthday-card-info {
                    margin: 6px 0;
                    font-size: 10px;
                    color: #5a3939;
                }

                .birthday-card-button {
                    margin-top: 10px;
                    padding: 8px 20px;
                    background-color: #ff7f7f;
                    color: #fff;
                    border: none;
                    border-radius: 25px;
                    font-size: 10px;
                    cursor: pointer;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
                    transition: all 0.3s ease;
                }

                .birthday-card-button:hover {
                    background-color: #ff5252;
                }

                @media (max-width: 480px) {
                    .birthday-card-container {
                        width: 95vw;
                        max-width: 380px;
                        height: auto;
                        aspect-ratio: 430/230;
                    }

                    .birthday-card-photo {
                        top: 11%;
                        left: 11.6%;
                        width: 27.2%;
                        height: 53%;
                    }

                    .birthday-card-details {
                        top: 30%;
                        left: 51%;
                        right: 5%;
                    }

                    .birthday-card-name {
                        font-size: clamp(10px, 2.8vw, 12px);
                        margin: 0 0 8px 0;
                    }

                    .birthday-card-info {
                        font-size: clamp(8px, 2.3vw, 10px);
                        margin: 4px 0;
                    }

                    .birthday-card-button {
                        margin-top: 8px;
                        padding: 6px 16px;
                        font-size: clamp(8px, 2.3vw, 10px);
                    }
                }

                @media (max-width: 360px) {
                    .birthday-card-container {
                        width: 98vw;
                    }

                    .birthday-card-details {
                        left: 50%;
                    }
                }
            `}</style>

            <div className="birthday-card-container">
                {/* 🎨 Background template */}
                <img
                    src={Template}
                    alt="Birthday Template"
                    className="birthday-card-bg"
                />

                {/* 🖼️ Employee photo */}
                <img
                    src={employee?.photo || UserAvatar}
                    alt="Employee"
                    className="birthday-card-photo"
                />

                {/* ✨ Text details */}
                <div className="birthday-card-details">
                    <h2 className="birthday-card-name">
                        {employeeName}! 🎉
                    </h2>
                    <p className="birthday-card-info">
                        {designation}
                    </p>
                    <p className="birthday-card-info">
                        {departmentName} Department
                    </p>
                    <p className="birthday-card-info">
                        {organizationName}
                    </p>

                    {/* 🎁 Send Wishes Button */}
                    <button
                        onClick={showModal}
                        className="birthday-card-button"
                    >
                        Send Wishes
                    </button>
                </div>

                {/* 💬 Modal for Sending Wishes */}
                <Modal
                    title={`Send a Wish to ${employeeName} 🎂`}
                    open={isModalVisible}
                    onCancel={handleCancel}
                    onOk={handleSendWish}
                    okText="Send"
                    color="green"
                    cancelText="Cancel"
                    centered
                    okButtonProps={{
                        style: {
                            backgroundColor: "#ff7f7f",
                            borderColor: "#ff7f7f",
                            color: "#fff",
                            fontWeight: 600,
                            transition: "all 0.3s ease",
                        },
                        onMouseEnter: (e) => (e.currentTarget.style.backgroundColor = "#ff5252"),
                        onMouseLeave: (e) => (e.currentTarget.style.backgroundColor = "#ff7f7f"),
                    }}
                >
                    <TextArea
                        rows={4}
                        placeholder="Type your heartfelt birthday wishes here..."
                        value={wishText}
                        onChange={(e) => setWishText(e.target.value)}
                        style={{
                            borderRadius: "8px",
                            resize: "none",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    />
                </Modal>
            </div>
        </>
    );
}